import { jsonPut } from "../../api";

export const updateAnalysis = async (analysisId, dto) =>
  await jsonPut(`/analyses/${analysisId}`, dto);
